import { render, staticRenderFns } from "./PassConfirmForm.vue?vue&type=template&id=1dbd99c5"
import script from "./PassConfirmForm.vue?vue&type=script&lang=js"
export * from "./PassConfirmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports